import axios from "axios";

const headers = (token) => ({ Authorization: `Bearer ${token}` });

export const getCompetitionVotersLeaderboard = (token, id) =>
  axios.get(
    `${process.env.REACT_APP_API_URL_USER}/getCompetitionVotersLeaderboard/${id}`,
    { headers: headers(token) }
  );

export const getFashionVotersLeaderboard = (token, designerId) =>
  axios.get(
    `${process.env.REACT_APP_API_URL_USER}/getFashionVotersLeaderboard?designerId=${designerId}`,
    { headers: headers(token) }
  );
